import { useState, useEffect } from 'react'
import { listTenants } from '../services/tenant-api'
import type { Tenant, ListTenantsParams } from '../types/tenant.types'

interface UseTenantsState {
  tenants: Tenant[]
  loading: boolean
  error: Error | null
  refresh: () => void
}

export function useTenants(params?: ListTenantsParams): UseTenantsState {
  const [tenants, setTenants] = useState<Tenant[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<Error | null>(null)
  const [refreshKey, setRefreshKey] = useState(0)

  useEffect(() => {
    let cancelled = false

    const fetchTenants = async () => {
      try {
        setLoading(true)
        setError(null)
        const response = await listTenants(params)
        if (!cancelled) {
          setTenants(response.data)
          setLoading(false)
        }
      } catch (err) {
        if (!cancelled) {
          setError(err instanceof Error ? err : new Error('Failed to fetch tenants'))
          setLoading(false)
        }
      }
    }

    fetchTenants()

    return () => {
      cancelled = true
    }
  }, [params?.includeInactive, params?.includeFeatureFlags, params?.includeUserCount, refreshKey])

  const refresh = () => {
    setRefreshKey((prev) => prev + 1)
  }

  return { tenants, loading, error, refresh }
}
